<div>{{drughistory.name}}</div>